module.exports = __webpack_public_path__ + "img/TWC logo.45a3dfe8.svg";